<ng-container *ngIf="fileEntry">
  <div class="d-flex align-items-center mt-4 cursor-pointer"
    (click)="onDownloadFile()">
    <span class="mr-3">{{ fileEntry.fileName }}</span>
    <svg icon
      ibmIconDownload
      class="fill-interactive cursor-pointer"
      size="16"></svg>
  </div>
</ng-container>